/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./menu-transfer-dialog.vue?vue&type=template&id=4c02d3b7&scoped=true&"
import script from "./menu-transfer-dialog.vue?vue&type=script&lang=js&"
export * from "./menu-transfer-dialog.vue?vue&type=script&lang=js&"
import style0 from "./menu-transfer-dialog.vue?vue&type=style&index=0&id=4c02d3b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c02d3b7",
  null
  
)

export default component.exports